import React from 'react';

import { componentTypes } from '@white-nl/instantsearch-components';
import DOMPurify from 'dompurify';
import Picture from '../../../ui/Picture';

export default function Hit({ hit }: componentTypes.HitProps) {
  const {
    title,
    articleDate,
    articleDateFormatted,
    description,
    image,
    url,
  } = hit;

  return (
    <div className="col">
      <a className="card-news" href={url}>
        <div className="card-news-img">
          <Picture image={image} defaultTransform="xxl-min" loading="lazy" />
          <div className="card-news-head">
            <time className="time" dateTime={articleDate.toString()}>{articleDateFormatted}</time>
            <h3
              className="h4"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
            />
            <p className="fs-5 mb-1">{description}</p>
          </div>
        </div>
      </a>
    </div>
  );
}
